var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg14Rocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 17.8125C37 20.1942 35.0692 22.125 32.6875 22.125C30.3058 22.125 28.375 20.1942 28.375 17.8125C28.375 15.4308 30.3058 13.5 32.6875 13.5C35.0692 13.5 37 15.4308 37 17.8125Z",
    fill: "#26B89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 29.3125C15.4375 29.3125 18.6 17.525 25.5 10.625C34.125 2 48.5 2 48.5 2C48.5 2 48.5 16.375 39.875 25C34.8416 30.0335 21.1875 35.0625 21.1875 35.0625M15.4375 29.3125L21.1875 35.0625M15.4375 29.3125C15.4375 29.3125 11.2598 32.0527 8.25 35.0625C5.375 37.9375 2.5 48 2.5 48C2.5 48 12.5625 45.125 15.4375 42.25C18.3125 39.375 21.1875 35.0625 21.1875 35.0625M25.5 48L34.125 29.3125M21.1875 16.375L2.5 25M37 17.8125C37 20.1942 35.0692 22.125 32.6875 22.125C30.3058 22.125 28.375 20.1942 28.375 17.8125C28.375 15.4308 30.3058 13.5 32.6875 13.5C35.0692 13.5 37 15.4308 37 17.8125Z",
    stroke: "#274A34",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14Rocket);
export default __webpack_public_path__ + "static/media/14_rocket.510c088e089c80250c7e81e6a3d97c5c.svg";
export { ForwardRef as ReactComponent };